import View from './base';

export default View.extend( {
	render: function() {
		this.findElements();

		this.renderSlug();
		this.renderTriggerLink();

		this.bindDetails();
	},
} );
